export const firebaseConfig = {
    apiKey: "AIzaSyDFDTwA_ogkXcF_QUHCV0Aqc4j9jUsCpNs",
    authDomain: "tcs-manager.firebaseapp.com",
    databaseURL: "https://tcs-manager.firebaseio.com",
    projectId: "tcs-manager",
    storageBucket: "",
    messagingSenderId: "664999425706",
    appId: "1:664999425706:web:40a0d9ee687e54961d42d3",
    measurementId: "G-SX8SP9YLZ7"
  };